// Single source of truth for design tokens.
// Consumed by tailwind.config.js (CJS) and src/providers/index.tsx (TS via allowJs).
// SCSS variables in src/styles/base/_variables.scss must be kept in sync manually.

const colors = {
  primary: '#84AB42',
  primaryHover: '#94BB52',
  primaryActive: '#74995C',
  header: '#463E4D',
  bgContainer: '#F4F4F4',
  bgBase: '#FFFFFF',
  border: '#CCCCCC',
  borderSubtle: '#E5E5E5',
  text: '#1F2328',
  textSecondary: '#666666',
  textMuted: '#999999',
  danger: '#F5222D',
};

const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '40px',
};

const radius = {
  sm: '4px',
  md: '6px',
  lg: '8px',
};

const fontSize = {
  xs: '12px',
  sm: '13px',
  base: '14px',
  md: '15px',
  lg: '16px',
  xl: '18px',
  '2xl': '20px',
};

const lineHeight = {
  tight: '1.2',
  normal: '1.5',
  relaxed: '1.7',
};

const layout = {
  sidebarWidth: '240px',
  sidebarCollapsedWidth: '64px',
  headerHeight: '48px',
  contentMaxWidth: '1280px',
};

module.exports = {
  colors,
  spacing,
  radius,
  fontSize,
  lineHeight,
  layout,
};
